const defaultGeneralStyleValues = {
    "primaryThemeColor": "#FFFFFF",
    "secondaryThemeColor": "#000000",
    "thirdThemeColor": "#FFFFFF",
    "fourthThemeColor": "#000000",
    "fifthThemeColor": "#f0f0f0",
    "sixthThemeColor": "#000000",
}

export { defaultGeneralStyleValues }